import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';

import ProjectList from './pages/ProjectList';
import ThreateningText from './pages/ThreateningText';
import DigitalEngineeringHub from './pages/DigitalEngineeringHub';
import DigitalEngineeringTools from './pages/DigitalEngineeringTools';
import Capabilitymatters from './pages/Capabilitymatters'; // PascalCase to match component convention
import LessIsMore from './pages/LessIsMore'; // PascalCase to match component convention
import RESTGIS from './pages/RESTGIS'; // PascalCase to match component convention
import TwoTierAI from './pages/TwoTierAI';
import CharitySurfEvent from './pages/CharitySurfEvent';
import PrismNews from './pages/PrismNews';
import MarcoPollo from './pages/MarcoPollo';


const AppRoutes = () => {
  return (
    <Switch>
      <Route path="/projects" exact component={ProjectList} />
      <Route path="/threatening-text" exact component={ThreateningText} />
      <Route path="/digital-engineering-hub" exact component={DigitalEngineeringHub} />
      <Route path="/DigitalEngineeringTools" exact component={DigitalEngineeringTools} />
      <Route path="/Capabilitymatters" exact component={Capabilitymatters} />
      <Route path="/LessIsMore" exact component={LessIsMore} />
      <Route path="/RESTGIS" exact component={RESTGIS} />
      <Route path="/TwoTierAI" exact component={TwoTierAI} />
      <Route path="/CharitySurfEvent" exact component={CharitySurfEvent} />
      <Route path="/PrismNews" exact component={PrismNews} />
      <Route path="/MarcoPollo" exact component={MarcoPollo} />
      <Redirect from="/" to="/projects" />
    </Switch>
  );
};

function App() {
  return (
    <Router>
      <div className="App">
        <AppRoutes />
      </div>
    </Router>
  );
}

export default App;
